<template lang="pug">
  .feedInfo
    .row
        .col-12
            select(v-model="feedInfo.selectedValue").customInput.px-2
                option(v-for="feedOption in feedInfo.options" :value="feedOption.code") {{feedOption.name}}

            .settings.mt-4(v-if="selectedOption")
                .title Settings for {{feedInfo.selectedValue}}
                  .setting.mt-3(v-for="setting in selectedOption.settings" v-bind:key="setting.code")
                    InputComponent(v-bind:inputObject="setting" :ref="setting.code")
            
</template>

<script>
import {Validation} from '@/helpers'
import {InputComponent} from './../'
export default {
  name: 'FeedInfoComponent',
  props:{
    feedInfo: Object
  },
  components: {
      InputComponent
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
    validate(){
      return Validation.validateFromRefs(this.$refs)
    }
  },
  computed: {
      selectedOption: function () {
          return this.feedInfo.options.find(x => x.code == this.feedInfo.selectedValue)
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  @import url('@/less/global.less'); 
   .nav-tabs {
       a {
           color: #4a4a4a;
       }
       .active {
           color: @primary !important;
       }
   }
   .title {
       font-weight: bold;
   }
</style>
